import { useEffect } from "react";

interface IProps {
    onCancel: () => void;
}

const AgreementPopup = ({ onCancel }: IProps): JSX.Element => {
    useEffect(() => {
        // iframe에서 접근할 수 있도록 window 객체에 함수 추가
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (window as any).onCancel = onCancel;
    }, [onCancel]);

    return (
        <div id="termsModal-1" className="modal-terms modal-overlay">
            <div className="modal-content">
                <iframe src="/TERMS.html"
                style={{ width: '100%', height:'1000px', border: 'none' }}
                ></iframe>
                </div>
            </div>
    );
}

export default AgreementPopup;  